import { DEFAULT_COLS, DEFAULT_ROWS } from "./helper";
export const gridToDbRows = (oldRows = [], newGrid = []) => {
  const oldMap = new Map();

  oldRows.forEach((row) => {
    oldMap.set(row.row_index, {
      ...row,
      data: { ...(row.data || {}) },
    });
  });

  const patchRows = [];

  newGrid.forEach((row, rowIndex) => {
    const existing = oldMap.get(rowIndex) || {
      row_index: rowIndex,
      data: {},
    };

    const oldData = existing.data;

    const patch = {};

    const maxCols = Math.max(
      row.length,
      ...Object.keys(oldData).map(Number),
      0,
    );

    for (let colIndex = 0; colIndex < maxCols; colIndex++) {
      const newValue = row[colIndex] ?? "";
      const oldValue = oldData[colIndex] ?? "";

      // unchanged
      if (newValue === oldValue) continue;

      // remove
      if (newValue === "") {
        patch[colIndex] = null;
        delete existing.data[colIndex];
      } else {
        // add/update
        patch[colIndex] = newValue;
        existing.data[colIndex] = newValue;
      }
    }

    // only changed rows
    if (Object.keys(patch).length > 0) {
      patchRows.push({
        row_index: rowIndex,
        data: patch,
      });

      oldMap.set(rowIndex, existing);
    }
  });

  return {
    rows: patchRows,
    updatedRows: Array.from(oldMap.values()),
  };
};

export const dbToGrid = (rows) => {
  const maxRow = Math.max(...rows.map((r) => r.row_index), 0) + 1;

  const maxCol =
    Math.max(...rows.flatMap((r) => Object.keys(r.data || {}).map(Number)), 0) +
    1;

  const rowCount = Math.max(maxRow, DEFAULT_ROWS);
  const colCount = Math.max(maxCol, DEFAULT_COLS);

  const grid = Array.from({ length: rowCount }, () => Array(colCount).fill(""));

  rows.forEach((row) => {
    Object.entries(row.data || {}).forEach(([c, value]) => {
      grid[row.row_index][Number(c)] = value ?? "";
    });
  });

  return {
    data: grid,
    colCount,
    rowCount,
  };
};
